export default "__VITE_ASSET__829e0ce2__"